import { Box, Button, Divider, Grid, Paper, Typography, useMediaQuery, useTheme, IconButton, Collapse, Alert, Menu, MenuItem } from "@mui/material";
import ReportLibrarySideBar from "../../../Pages/ReportLibrary/ReportLibrarySideBar";
import { Close as CloseIcon, Image as ImageIcon } from '@mui/icons-material';
import { AddrecMenu, EditMenu, InfoMenu, LongMenu, RegenerateMenu, ShortMenu, Uploads } from "../../../../Assets/Svg/Svg";
import { useCallback, useEffect, useState } from "react";
import {
    Chip,
    CircularProgress,
    Skeleton,
    Checkbox,
    Autocomplete,
    TextField,
    Stack,
} from "@mui/material";
import { useMemo } from "react";
import { Done, ErrorOutlineOutlined } from "@mui/icons-material";
import LoadingIcon from "../../../../Assets/Images/brain.png";
import "../../../../Assets/Styles/Containers/_commentLibraryModal.scss";
import { DoneIconAi, Replay } from "../../../../Assets/Svg/Svg";
import React from "react";
import { ReactComponent as AiEditIcon } from "../../../../Assets/Images/ai edit.svg";
import { ReactComponent as AiEditIconHover } from "../../../../Assets/Images/ai edit 1.svg";
import Popper from "@mui/material/Popper";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import axios from "axios";
import DailyCreditsAlert from "./CreditAlert";
import { aiUrl } from "../../../Config/Api-constants";


function formatAIResponseToHTML(text) {
    if (!text) return "";
    text = text.replace(/#+|[*]{2}/g, "").trim();

    let bulletCount = 1;
    const processed = text.split("\n").map((line) => {
        line = line.trim();
        if (!line || /^Title\s*:/i.test(line)) return "";

        if (/Summary\s*-/.test(line)) {
            return `Summary - ${line.replace(/Summary\s*-\s*/, "")}`;
        }
        if (/^[-•–]\s+/.test(line)) {
            return `${bulletCount++}. ${line.replace(/^[-•–]\s+/, "")}`;
        }
        if (/^\s+[-•–]\s+/.test(line)) {
            return `&nbsp;&nbsp;&nbsp;&nbsp;• ${line.replace(/^\s*[-•–]\s+/, "")}`;
        }
        return line;
    });

    return processed.filter(Boolean).join("<br/>");
}

function formatAIResponseToHTMLTitle(text) {
    if (!text) return { html: "", title: "" };
    let title = "";
    const titleMatch = text.match(/Title:\s*(.*)/i);
    if (titleMatch) {
        title = titleMatch[1].trim();
        text = text.replace(titleMatch[0], "");
    }
    return {
        title
    };
}

// const summaryOptions = [
//     { label: "Safety–Mold", color: "red" },
//     { label: "Roofing", color: "gray" },
//     { label: "HVAC", color: "black" },
//     { label: "Misc.", color: "cyan" },
// ];
function AIDefectFinder(props) {
    const { loading,
        openData,
        medialLibery,
        sideBarActive,
        RenderContent,
        handleImageUpload,
        setMedialLibery,
        storeData,
        images,
        handleRemoveImage,
        dataLoading,
        defaultSelect,
        datas,
        setDefaultSelect,
        selectedContent,
        setDatas,
        handleRetry,
        handleCheckbox,
        handleSelect,
        value,
        selectedImages,
        setSelectedImages,
        onDragtoggle,
        setOnDragToggle,
        selectedMediaFiles,
        setSelectedMediaFiles,
        type,
        remainingImages,
        promptUsed,
        manualPrompt,
        includeRecommendation,
        categoryName,
        lineName,
        setDataLoading,
        setSelectedContent
    } = props;

    const [isDragOver, setIsDragOver] = useState(false);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [loadings, setLoading] = useState(false);
    const { title } = formatAIResponseToHTMLTitle(selectedContent?.ai_response || "");
    const [summarySelections, setSummarySelections] = useState({});
    const handleSummaryChange = (imageName, newValue) => {
        setSummarySelections((prev) => ({
            ...prev,
            [imageName]: newValue, // store per image
        }));
    };
    const [open, setOpen] = React.useState(false);
    const defectFinder = storeData?.defectData || {};
    const [editText, setEditText] = useState("");
    // Dropdown menu state - NEW ADDITION
    const [anchorEl, setAnchorEl] = useState(null);
    const [isClicked, setIsClicked] = useState(false);
    const handleClickAi = () => setIsClicked(true);
    const menuOpen = Boolean(anchorEl);
    const [currentPromptSettings, setCurrentPromptSettings] = useState({
        type: promptUsed || 'Short',
        includeRecommendation: includeRecommendation || false
    });

    // Dropdown menu handlers - NEW ADDITION
    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
        setShowRegenerateBox(false);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
        setShowRegenerateBox(false);
        setIsClicked(false);
    };

    useEffect(() => {
        if (manualPrompt) {
            setEditText(manualPrompt)
        }
    }, [manualPrompt])

    const menuItemStyles = {
        color: "#3B3B3B",
        fontFamily: "Source Sans Pro",
        fontWeight: 400,
        fontSize: "14px",
        lineHeight: "24px",
        letterSpacing: "0px",
        width: 243,
        height: 32,
        pt: "4px",
        pr: "16px",
        pb: "4px",
        pl: "16px",
        gap: "18px",
        transform: "rotate(0deg)",
        opacity: 1,
        display: "flex",
        alignItems: "center",
    };
    const [showRegenerateBox, setShowRegenerateBox] = useState(false);
const handleAction = async (action) => {
    if (action === "editContext") {
        setShowRegenerateBox((prev) => !prev);
    } else if (action === "editRegenerate") {
        setRegenerationLoading(true); 
        await handleReAnalyseImage(selectedContent, currentPromptSettings);
        setShowRegenerateBox((prev) => !prev);
        setAnchorEl(null);
        setIsClicked(false);
        setRegenerationLoading(false);
    } else {
        console.log("action:", action);
        setShowRegenerateBox(false);

        let newSettings = { ...currentPromptSettings };

        if (action === "Short" || action === "Long") {
            newSettings.type = action;
        } else if (action === "addRecommendation") {
            newSettings.includeRecommendation = !currentPromptSettings.includeRecommendation;
        } else if (action === "regenerate") {
        }
        
        setRegenerationLoading(true); 
        await handleReAnalyseImage(selectedContent, newSettings); 

        setCurrentPromptSettings(newSettings);
        setAnchorEl(null);
        setIsClicked(false);
        setRegenerationLoading(false); 
    }
};
    const selectedAiResponse = selectedContent?.ai_response || "";
    const hasSelectedApologyMessage = selectedAiResponse.toLowerCase().includes("i'm sorry") ||
        selectedAiResponse.toLowerCase().includes("i can't assist") ||
        selectedAiResponse.toLowerCase().includes("i cannot assist") ||
        selectedAiResponse.toLowerCase().includes("unable to");

  const handleDrop = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragOver(false);
    const dt = e.dataTransfer;
    const out = [];
    
    // 1) FIRST: Check for multiple images from gallery drag
    const multipleImagesData = dt.getData('application/json');
    if (multipleImagesData) {
        try {
            const parsedData = JSON.parse(multipleImagesData);
            if (parsedData.type === 'multiple-images' && Array.isArray(parsedData.images)) {
                parsedData.images.forEach(img => {
                    out.push({
                        name: img.name,
                        file: img.file,
                        size: img.size,
                        type: img.type,
                        uuid: img.uuid ?? null,
                    });
                });
            }
        } catch (error) {
            console.error('Error parsing multiple images data:', error);
        }
    }
    
    // 2) Real files (existing logic - unchanged)
    const fileList = Array.from(dt.files || []).filter((f) => 
        f.type.startsWith('image/') || f.type === 'application/pdf'
    );
    out.push(...fileList);

    // 3) URLs (existing logic - unchanged)
    const uriList = dt.getData('text/uri-list');
    if (uriList && out.length === 0) {
        uriList.split(/\r?\n/)
            .filter(Boolean)
            .forEach((u) => {
                out.push({ 
                    name: u.split('/').pop() || 'image', 
                    file: u, 
                    size: 0, 
                    type: 'image/png' 
                });
            });
    }

    // 4) text/plain fallback (existing logic - unchanged)
    const plain = dt.getData('text/plain');
    if (plain && out.length === 0) {
        out.push({ 
            name: plain.split('/').pop() || 'image', 
            file: plain, 
            size: 0, 
            type: 'image/png' 
        });
    }

    // 5) Process the files (existing logic - unchanged)
    if (out.length > 0) {
        const currentCount = Array.isArray(images) ? images.length : 0;
        const availableSlots = Math.max(0, 10 - currentCount);

        // CHECK FOR ALERT
        if (availableSlots <= 0 || remainingImages <= 0) {
            setOpen(true);
            return;
        }

        const actualLimit = Math.min(availableSlots, remainingImages);

        // SHOW ALERT IF TRYING TO UPLOAD MORE THAN ALLOWED
        if (out.length > actualLimit) {
            setOpen(true);
        }

        const filesToUpload = out.slice(0, actualLimit);

        if (filesToUpload.length > 0) {
            handleImageUpload(filesToUpload);
        }
    }
}, [handleImageUpload, images, remainingImages]);
   const [regenerationLoading, setRegenerationLoading] = useState(false);

    const [showCommentGenerated, setShowCommentGenerated] = useState({});
    const [titleTimers, setTitleTimers] = useState({});
    const [leftTitle, setLeftTitle] = useState("");
    useEffect(() => {
        images?.forEach((image) => {
            const imageName = image.file.name;
            const hasTitle = formatAIResponseToHTMLTitle(datas[imageName]?.ai_response || "").title;
            setLeftTitle(hasTitle);
            const isLoading = dataLoading[imageName];

            if (leftTitle && !isLoading && showCommentGenerated[imageName] === undefined) {
                setShowCommentGenerated(prev => ({
                    ...prev,
                    [imageName]: true
                }));

                const timerId = setTimeout(() => {
                    setShowCommentGenerated(prev => ({
                        ...prev,
                        [imageName]: false
                    }));
                }, 10000);

                setTitleTimers(prev => ({
                    ...prev,
                    [imageName]: timerId
                }));
            }

            if (isLoading && showCommentGenerated[imageName] !== undefined) {
                if (titleTimers[imageName]) {
                    clearTimeout(titleTimers[imageName]);
                }

                setShowCommentGenerated(prev => ({
                    ...prev,
                    [imageName]: undefined
                }));

                setTitleTimers(prev => {
                    const newTimers = { ...prev };
                    delete newTimers[imageName];
                    return newTimers;
                });
            }
        });
    }, [images, datas, dataLoading, showCommentGenerated, titleTimers]);


    useEffect(() => {
        return () => {
            Object.values(titleTimers).forEach(timerId => {
                clearTimeout(timerId);
            });
        };
    }, [titleTimers]);

    const MAX_FILE_SIZE = 20 * 1024 * 1024;
    const ALLOWED_TYPES = ["image/png", "image/jpeg", "image/jpg"];

    const handleDragOver = (e) => { e.preventDefault(); setIsDragOver(true); };
    const handleDragLeave = (e) => { e.preventDefault(); setIsDragOver(false); };
    const [clickedIcon, setClickedIcon] = useState(null);
    const handleIconClick = (imageName) => {
        setClickedIcon(clickedIcon === imageName ? null : imageName);
    };

const handleClick = () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.multiple = true;
    input.accept = 'image/*,.pdf';
    input.addEventListener('change', (e) => {
        const target = e.target;
        const files = Array.from(target.files || []);
        if (files.length > 0) {
            const currentCount = Array.isArray(images) ? images.length : 0;
            const availableSlots = Math.max(0, 10 - currentCount);

            // CHECK FOR ALERT BEFORE UPLOADING
            if (availableSlots <= 0 || remainingImages <= 0) {
                setOpen(true);
                return;
            }

            const actualLimit = Math.min(availableSlots, remainingImages);

            // SHOW ALERT IF TRYING TO UPLOAD MORE THAN ALLOWED
            if (files.length > actualLimit) {
                setOpen(true);
            }

            const filesToUpload = files.slice(0, actualLimit);

            if (filesToUpload.length > 0) {
                setUploadedFiles((prev) => [...prev, ...filesToUpload]);
                handleImageUpload(filesToUpload);
            }
        }
    });
    input.click();
};

    const generateComment = useCallback((template = '', category = '', line = '', issue = '', charLimit = '') => {
        return template
            .replace("{{category}}", category || '')
            .replace("{{line_item}}", line || '')
            .replace("{{user_prompt}}", issue || '')
            .replace("{char_limit_default}", charLimit)
            .replace("{char_limit_longer}", charLimit)
            .replace("{char_limit}", charLimit);
    }, []);

    useEffect(() => {
        setCurrentPromptSettings({
            type: promptUsed || 'Short',
            includeRecommendation: includeRecommendation || false
        });
    }, [promptUsed, includeRecommendation]);

    const getPromptTemplateForSettings = (settings) => {
        if (defectFinder?.defect_detector_prompts?.prompt) {
            const { type, includeRecommendation } = settings;

            if (type === 'Short' && !includeRecommendation) {
                return defectFinder.defect_detector_prompts.prompt.short;
            } else if (type === 'Short' && includeRecommendation) {
                return defectFinder.defect_detector_prompts.prompt.short_with_recommendation;
            } else if (type === 'Long' && !includeRecommendation) {
                return defectFinder.defect_detector_prompts.prompt.long;
            } else if (type === 'Long' && includeRecommendation) {
                return defectFinder.defect_detector_prompts.prompt.long_with_recommendation;
            } else {
                return defectFinder.defect_detector_prompts.prompt.short;
            }
        } else {
            return '';
        }
    };

    const getCharacterLimitForSettings = (settings) => {
        if (defectFinder?.defect_detector_prompts?.char_limits) {
            const { type } = settings;

            if (type === 'Short') {
                return defectFinder.defect_detector_prompts.char_limits.char_limit_default;
            } else if (type === 'Long') {
                return defectFinder.defect_detector_prompts.char_limits.char_limit_longer;
            } else {
                return defectFinder.defect_detector_prompts.char_limits.char_limit_default;
            }
        } else {
            return '';
        }
    };

    function aiEnvUrl() {
        if (window.location.hostname === "portal.palmtech.com") {
            return "https://prod-genie-ai.inspectionsupport.com/api/gpt/upload-and-analyse/"
        } else {
            return "https://staging-genie-ai.inspectionsupport.com/api/gpt/upload-and-analyse/"
        }
    }

    function aiEnvToken() {
        if (window.location.hostname === "portal.palmtech.com") {
            return "token 1854f0ae670ad92120482d3f233da72cfab4c41c"
        } else {
            return defectFinder?.ai_token
        }
    }

    const handleReAnalyseImage = async (selecteContent, settings = currentPromptSettings) => {
        // Use the provided settings or current state
        const currentPromptTemplate = getPromptTemplateForSettings(settings);
        const currentPromptLimit = getCharacterLimitForSettings(settings);

        const result = generateComment(currentPromptTemplate, categoryName, lineName, editText, currentPromptLimit);
        const formData = new FormData();
        // Attach either binary file or S3 URL
        if (selecteContent?.file?.file instanceof File || selecteContent?.file?.file instanceof Blob) {
            formData.append("file", selecteContent.file.file);
        } else if (typeof selecteContent.file?.file?.file === "string") {
            formData.append("s3_image_urls", selecteContent.file.file.file);
        }
        formData.append("prompt", result);

        try {
            // Set loading state for this specific image
            setDataLoading(prev => ({
                ...prev,
                [selecteContent.name]: true
            }));

            const res = await axios.post(
                aiUrl(),
                formData,
                {
                    headers: {
                        Authorization: defectFinder?.ai_token || '',
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            if (res.status === 200) {

                // Extract title from the original (unformatted) AI response
                const { title: newTitle } = formatAIResponseToHTMLTitle(res.data.ai_response);

                // Update the datas state with the new AI response AND title for this specific content
                setDatas(prev => ({
                    ...prev,
                    [selecteContent.name]: {
                        ...prev[selecteContent.name],
                        ai_response: res.data.ai_response,
                        title: newTitle,
                        checked: prev[selecteContent.name]?.checked || false,
                        file: selecteContent.file
                    }
                }));

                // If this is the currently selected content, update selectedContent as well
                if (selectedContent && selectedContent.name === selecteContent.name) {
                    setSelectedContent(prev => ({
                        ...prev,
                        ai_response: res.data.ai_response,
                        title: newTitle
                    }));
                }

                console.log('Successfully updated AI response and title for:', selecteContent.name);
            }
        } catch (err) {
            setDataLoading(prev => ({
                ...prev,
                [selecteContent.name]: "error"
            }));
        } finally {
            setDataLoading(prev => ({
                ...prev,
                [selecteContent.name]: false
            }));
        }
    }

    useEffect(() => {
        const currentCount = Array.isArray(images) ? images.length : 0;
        const availableSlots = Math.max(0, 10 - currentCount);
        const actualLimit = Math.min(availableSlots, remainingImages);

        if (actualLimit > 0) {
            setOpen(false);
        }
    }, [images, remainingImages]);
    function isNotImage(filename) {
        return (
            filename.toLowerCase().endsWith(".jpg") ||
            filename.toLowerCase().endsWith(".jpeg") ||
            filename.toLowerCase().endsWith(".png")
        );
    }

 const sidebarImages = useMemo(
  () =>
    images?.map((image) => {
      const isSelected = image.id === defaultSelect;
      const isDrag = typeof image.file?.file === "string";
      const key = isDrag ? image.name : image.file.name;
      
      const isLoading = dataLoading[key];
      const selectedComment = datas[key]?.checked || false;
      const aiResponse = datas[key]?.ai_response || "";
      
      // Check if image is valid - ONLY JPG, JPEG, PNG allowed
      const isFileObject = image?.file instanceof File;
      const fileSize = isFileObject ? image.file.size : 0;
      const fileType = isFileObject ? image.file.type : image.type || "";
      const isValidImage = fileSize <= MAX_FILE_SIZE && 
                          (fileType === "image/jpeg" || 
                           fileType === "image/jpg" || 
                           fileType === "image/png");

      // Check for apology message in AI response
      const hasApologyMessage = aiResponse.toLowerCase().includes("i'm sorry") ||
        aiResponse.toLowerCase().includes("i can't assist") ||
        aiResponse.toLowerCase().includes("i cannot assist") ||
        aiResponse.toLowerCase().includes("unable to") ||
        aiResponse.toLowerCase().includes("as an ai");

      // Image is disabled ONLY if it's invalid file type/size
      const isImageDisabled = !isValidImage;

      return (
        <Grid
          container
          key={image.id}
          gap={2}
          height={94}
          p={2}
          mb={2}
          border={selectedComment ? 2 : 1}
          width="285px"
          borderColor={
            isImageDisabled 
              ? "#E0E0E0" 
              : (isSelected || selectedComment ? "#4282E2" : "#D5D5D5")
          }
          bgcolor={
            isImageDisabled 
              ? "#F9F9F9" 
              : (isSelected ? "#f0f6ff" : "#fff")
          }
          borderRadius={2}
          onClick={() => !isImageDisabled && setDefaultSelect(key, image.id)}
          sx={{ 
            cursor: isImageDisabled ? "not-allowed" : "pointer",
            opacity: isImageDisabled ? 0.6 : 1,
            filter: isImageDisabled ? "grayscale(0.3)" : "none",
            '&:hover': {
              bgcolor: isImageDisabled ? "#F9F9F9" : (isSelected ? "#f0f6ff" : "#f8f8f8")
            }
          }}
          display={"flex"}
          wrap="nowrap"
          padding={"12px"}
        >
          <Box position="relative">
            {selectedComment && !isImageDisabled &&
              <Typography
                sx={{
                  height: 15,
                  borderRadius: "50px",
                  position: "absolute",
                  opacity: 1,
                  margin: "auto",
                  top: 0,
                  bottom: 70,
                  left: -7,
                  display: "flex",
                  alignItems: "center",
                  gap: "2px",
                  bgcolor: "#4282E2",
                  fontWeight: 600,
                  padding: "2px 2px 2px 4px",
                  fontSize: "8px !important",
                  lineHeight: "100%",
                  letterSpacing: "0px",
                  verticalAlign: "middle",
                  textTransform: "uppercase",
                  color: "#FFFFFF",
                }}
              >
                SELECTED <DoneIconAi />
              </Typography>
            }

            <Box
              component="img"
              src={image?.file instanceof File ? URL.createObjectURL(image.file) : image?.file?.file || image?.preview?.file}
              alt={image.name}
              sx={{
                objectFit: "cover",
                borderRadius: 1,
                width: { xs: 50, sm: 62, lg: 65 },
                height: { xs: 50, sm: 62, lg: 65 },
                filter: isImageDisabled ? "grayscale(1)" : "none",
                opacity: isImageDisabled ? 0.5 : 1,
              }}
            />
            {image.status === "analyzing" && (
              <Box
                sx={{
                  position: "absolute",
                  inset: 0,
                  bgcolor: "rgba(0,0,0,0.1)",
                  borderRadius: 1,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <CircularProgress size={16} />
              </Box>
            )}
          </Box>

          <Box>
            {isImageDisabled ? (
              // SHOW SAME ERROR FOR ALL INVALID IMAGES
              <div>
                <Typography variant="body2" sx={{ display: "flex", alignItems: "center", gap: 1, color: "#4B5157" }}>
                  <ErrorOutlineOutlined sx={{ color: "#e30202" }} color="#FF0000" />
                  Error generating Comment
                </Typography>
              </div>
            ) : (isLoading === "error" || hasApologyMessage ? (
              <div>
                <Typography variant="body2" sx={{ display: "flex", alignItems: "center", gap: 1, color: "#4B5157" }}>
                  <ErrorOutlineOutlined sx={{ color: "#e30202" }} color="#FF0000" />
                  {hasApologyMessage ? "Error generating Comment" : "Error generating Comment"}
                </Typography>
                {/* KEEP EXISTING RETRY FUNCTIONALITY - only for valid images with AI errors */}
                <Typography
                  color={"#4282E2"}
                  display={'flex'}
                  sx={{
                    cursor: "pointer",
                    '&:hover': {
                      opacity: 0.8
                    }
                  }}
                  alignItems={'center'}
                  justifyContent={'end'}
                  mt={1}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    console.log('Retry clicked for:', image.name);
                    handleRetry(image);
                  }}
                >
                  <Replay />
                  Retry
                </Typography>
              </div>
            ) : (isLoading ? (
              <>
                <Skeleton width={175} height={30} />
                <Typography variant="body2" sx={{ display: "flex", alignItems: "center", gap: 1, color: "#4B5157" }}>
                  {dataLoading[key] === true ? "Analyzing" : "Analyzing"}
                  <Box sx={{ display: "flex", gap: 0.5 }}>
                    {[...Array(3)].map((_, i) => (
                      <Box
                        key={i}
                        sx={{
                          width: 4,
                          height: 4,
                          bgcolor: "#2D2D2D",
                          borderRadius: "50%",
                          animation: "pulse 1.5s ease-in-out infinite",
                          animationDelay: `${i * 0.2}s`,
                          "@keyframes pulse": {
                            "0%, 80%, 100%": { opacity: 0.3 },
                            "40%": { opacity: 1 },
                          },
                        }}
                      />
                    ))}
                  </Box>
                </Typography>
              </>
            ) : (
              <>
                <Typography
                  sx={{
                    fontFamily: "Source Sans Pro, sans-serif",
                    fontWeight: 400,
                    fontStyle: "normal",
                    fontSize: "14px !important",
                    lineHeight: "20px",
                    letterSpacing: "0px",
                    color: "#262D33 !important",
                    overflow: "hidden",
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical",
                    textOverflow: "ellipsis",
                  }}
                >
                  {isDrag
                    ? (datas[image.name]?.title || formatAIResponseToHTMLTitle(datas[image.name]?.ai_response || "").title)
                    : (datas[image.name]?.title || formatAIResponseToHTMLTitle(datas[image.name]?.ai_response || "").title)
                  }
                </Typography>
                {showCommentGenerated && (
                  <Stack direction="row" alignItems="center" gap={0.5} >
                    <Typography
                      sx={{
                        fontFamily: "Source Sans Pro",
                        fontWeight: 400,
                        fontStyle: "normal",
                        fontSize: "12px !important",
                        lineHeight: "20px",
                        letterSpacing: "0px",
                        color: "#4B5157"
                      }}
                    >
                      Comment generated
                    </Typography>            
                    <Done sx={{ fontSize: 15, color: "#5bbe85" }} />
                  </Stack>
                )}
              </>
            )))}
            <Stack direction="row" spacing={1} mt={0.5}>
              {image.status === "completed" && !isImageDisabled && <Chip label="Complete" size="small" color="success" sx={{ fontSize: "0.75rem", height: 20 }} />}
              {/* {isImageDisabled && <Chip label="Invalid" size="small" color="error" sx={{ fontSize: "0.75rem", height: 20 }} />} */}
            </Stack>
          </Box>
        </Grid>
      );
    }),
  [images, dataLoading, defaultSelect, datas, setDefaultSelect]
);
    return (
        <>
            {!loading && !openData &&
                <Box
                    sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: 0,

                    }}
                >
                    <Box
                        sx={{
                            // height: "100%",
                            flex: {
                                xs: "100%",
                                sm: "100%",
                                lg: medialLibery && storeData?.reportSideBarActive ? "50%" : "50%",
                            },
                            borderRight: medialLibery && storeData?.reportSideBarActive ? "1px solid #ccc" : "none",
                            // maxHeight: "100vh",
                            width: "100%",
                            overflow: "auto",

                            /* 👇 Important fix */
                            scrollbarGutter: "stable", // prevents Chrome scrollbar enlargement

                            /* Firefox */
                            scrollbarWidth: "thin",
                            scrollbarColor: "#D9D9D9 white",

                            /* Chrome / WebKit */
                            "&::-webkit-scrollbar": {
                                width: "8px",
                            },
                            "&::-webkit-scrollbar-track": {
                                background: "white",
                            },
                            "&::-webkit-scrollbar-thumb": {
                                backgroundColor: "#D9D9D9",
                                borderRadius: "8px",
                            },
                            "&::-webkit-scrollbar-thumb:hover": {
                                backgroundColor: "red",
                            },

                            boxSizing: "border-box",
                        }}
                    >
                        <div className={`${medialLibery && storeData?.reportSideBarActive ? "image-upload-area-sidebar" : "image-upload-area"}`}>
                        {remainingImages === 0 && images.length === 0 ?
                            <DailyCreditsAlert /> :
                            images?.length === 0 ? (
                                <>

                                    <Paper
                                        variant="outlined"
                                        sx={{
                                            border: '1px dashed', borderColor: '#999999',
                                            borderRadius: 1,
                                            p: isMobile ? 3 : 6,
                                            maxWidth: "100% !important",
                                            height: isMobile ? "20vh" : "40vh",
                                            textAlign: 'center',
                                            transition: 'all 0.2s',
                                            transform: isDragOver ? 'scale(1.02)' : 'scale(1)',
                                            opacity: isDragOver ? 0.8 : 1,
                                            '&:hover': {
                                                borderColor: 'grey.400'
                                            },
                                        }}
                                        onDragOver={handleDragOver}
                                        onDragLeave={handleDragLeave}
                                        onDrop={handleDrop}
                                    >
                                        <Box
                                            sx={{
                                                width: 64,
                                                height: 64,
                                                mx: 'auto',
                                                mb: 2,
                                                borderRadius: 2,
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}
                                        >
                                            <Uploads sx={{ color: 'grey.400' }} />
                                        </Box>

                                        <Typography
                                            variant="h6"
                                            sx={{
                                                mb: 1,
                                                color: '#333333 !important',
                                                fontFamily: 'Open Sans !important',
                                                fontWeight: 600,
                                                fontSize: '20px',
                                                lineHeight: '20px',
                                                letterSpacing: '0px',
                                                textAlign: 'center'
                                            }}
                                        >
                                            Drag and drop images here
                                        </Typography>

                                        <Box sx={{ mb: 2 }}>
                                            <Typography variant="body2" color="textSecondary" sx={{ marginY: 1, display: "flex", justifyContent: "center", alignItems: "center", fontSize: "14px !important" }}>
                                                <Divider sx={{ border: "1px solid #D9D9D9", margin: "0.5rem", width: "100px" }} />
                                                OR
                                                <Divider sx={{ border: "1px solid #D9D9D9", margin: "0.5rem", width: "100px" }} />
                                            </Typography>
                                        </Box>

                                        <Button
                                            variant="outlined"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                handleClick();
                                            }}
                                            sx={{
                                                color: '#4282E2',
                                                fontWeight: 700,
                                                px: 6,
                                                borderColor: "#4282E2",
                                                borderRadius: "2px",
                                                fontSize: isMobile ? "12px" : "12px",
                                                whiteSpace: "nowrap",
                                                fontFamily: "Source Sans Pro !important",
                                                '&:hover': { backgroundColor: 'transparent' },
                                                '&:active': { backgroundColor: 'transparent' },
                                                '&.Mui-focusVisible': { backgroundColor: 'transparent' },
                                            }}
                                        >
                                            Browse files
                                        </Button>
                                    </Paper>
                                </>

                            ) : (
                                <Paper
                                    variant="outlined"
                                    sx={{
                                        border: '1px dashed #999999',
                                        py: 1.5,
                                        borderRadius: 1.5,
                                        px: "16px",
                                        height: isMobile ? "20vh" : "50vh",
                                        overflowY: 'auto',
                                        position: 'relative',
                                        textAlign: 'center',
                                        transition: 'all 0.2s',
                                        transform: isDragOver ? 'scale(1.02)' : 'scale(1)',
                                        opacity: isDragOver ? 0.8 : 1,
                                        '&:hover': {
                                            borderColor: 'grey.400'
                                        },

                                        '&::-webkit-scrollbar': {
                                            width: '6px',
                                        },
                                        '&::-webkit-scrollbar-track': {
                                            backgroundColor: '#f1f1f1',
                                            borderRadius: '10px',
                                        },
                                        '&::-webkit-scrollbar-thumb': {
                                            backgroundColor: '#b5b5b5',
                                            borderRadius: '10px',
                                        },
                                        '&::-webkit-scrollbar-thumb:hover': {
                                            backgroundColor: '#888',
                                        },
                                    }}

                                    onDragOver={handleDragOver}
                                    onDragEnter={handleDragOver}
                                    onDragLeave={handleDragLeave}
                                    onDrop={handleDrop}
                                >
                                    <Box display={"flex"} justifyContent={"space-between"} mb={1} textAlign={"start"}>

                                        <div>
                                            <Typography sx={{ fontSize: "20px !important", color: "#333333", mb: 0 }}>Drag and drop images here</Typography>
                                            <Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
                                                <Typography
                                                    sx={{
                                                        color: "#979797",
                                                        fontSize: isMobile ? "10.5px !important" : "10px !important",
                                                        whiteSpace: "nowrap",
                                                    }}
                                                >
                                                    Images selected: {images.length}
                                                </Typography>

                                                <Typography
                                                    sx={{
                                                        color: "#979797",
                                                        fontSize: isMobile ? "10.5px !important" : "13px !important",
                                                    }}
                                                >
                                                    |
                                                </Typography>

                                                <Typography
                                                    sx={{
                                                        color: "#979797",
                                                        fontSize: isMobile ? "10.5px !important" : "10px !important",
                                                        whiteSpace: "nowrap",
                                                    }}
                                                >
                                                    Credits remaining after upload: {defectFinder?.defect_detector_counter &&
                                                        defectFinder?.defect_detector_counter > 0 ?
                                                        defectFinder?.defect_detector_counter - images.length
                                                        : 0
                                                    }
                                                </Typography>
                                            </Box>
                                        </div>
                                        <Box>
                                            <Button

                                                variant="outlined"
                                                onClick={() => handleClick()}
                                                sx={{
                                                    color: '#4282E2',
                                                    fontWeight: 700,
                                                    px: 2.5,
                                                    mt: 1,
                                                    borderColor: "#4282E2",
                                                    borderRadius: "2px",
                                                    fontSize: isMobile ? "10px" : "12px",
                                                    fontFamily: "Source Sans Pro !important",
                                                    whiteSpace: "nowrap",
                                                    '&:hover': {
                                                        backgroundColor: 'transparent',
                                                    },
                                                    '&:active': {
                                                        backgroundColor: 'transparent',
                                                    },
                                                    '&.Mui-focusVisible': {
                                                        backgroundColor: 'transparent',
                                                    },
                                                }}
                                            >
                                                Browse files
                                            </Button>
                                        </Box>
                                    </Box>

                                    <Grid container spacing={2} sx={{ mb: 2 }} width="100%">
                                        {images &&
                                            images.length !== 0 &&
                                            images.map((image) => {
                                                const isDragImage = typeof image?.file?.file === "string";
                                                const isFileObject = image?.file instanceof File;
                                                const fileSize = isFileObject ? image.file.size : 0;
                                                const fileType = isFileObject ? image.file.type : "";
                                                const isValid =
                                                    fileSize <= MAX_FILE_SIZE && ALLOWED_TYPES.includes(fileType);
                                                const isInValidType = isDragImage && isNotImage(image?.file?.file);

                                                return (
                                                    <Grid
                                                        item
                                                        key={image.id}
                                                        sx={{
                                                            width: "auto",
                                                            display: "flex",
                                                            justifyContent: "flex-start",
                                                        }}
                                                    >
                                                        <Box
                                                            position="relative"
                                                            sx={{
                                                                width: "110px !important",
                                                                height: "108px !important",
                                                                borderRadius: 1,
                                                                overflow: "hidden",
                                                                display: "flex",
                                                                flexDirection: "column",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                border: "1px solid #D5D5D5",
                                                                bgcolor: "#F5F5F5",
                                                            }}
                                                        >
                                                            {(isValid) || (isDragImage && isInValidType) ? (
                                                                <>
                                                                    <Box
                                                                        component="img"
                                                                        src={
                                                                            isFileObject
                                                                                ? URL.createObjectURL(image.file)
                                                                                : typeof image?.preview === "string"
                                                                                    ? image.preview
                                                                                    : typeof image?.file === "string"
                                                                                        ? image.file
                                                                                        : image?.file?.file || image?.preview?.file
                                                                        }
                                                                        alt={image.name}
                                                                        sx={{
                                                                            width: "100%",
                                                                            height: "100%",
                                                                            objectFit: "cover",
                                                                            display: "block",
                                                                        }}
                                                                    />
                                                                    <IconButton
                                                                        size="small"
                                                                        onClick={() => handleRemoveImage(image.id)}
                                                                        sx={{
                                                                            position: "absolute",
                                                                            top: 4,
                                                                            right: 4,
                                                                            backgroundColor: "rgba(255,255,255,1)",
                                                                            borderRadius: "10%",
                                                                            border: "1px solid #D5D5D5",
                                                                            padding: "2px",
                                                                            "&:hover": {
                                                                                backgroundColor: "rgba(255,255,255,1)",
                                                                            },
                                                                        }}
                                                                    >
                                                                        <CloseIcon sx={{ color: "#454545", fontSize: "16px" }} />
                                                                    </IconButton>
                                                                </>
                                                            ) : (
                                                                // Error Card
                                                                <Box
                                                                    sx={{
                                                                        p: 1,
                                                                        textAlign: "center",
                                                                        display: "flex",
                                                                        flexDirection: "column",
                                                                        alignItems: "center",
                                                                        justifyContent: "center",
                                                                        height: "100%",
                                                                        width: "100%",
                                                                        position: "relative",
                                                                    }}
                                                                >
                                                                    {/* Close Icon */}
                                                                    <IconButton
                                                                        size="small"
                                                                        onClick={() => handleRemoveImage(image.id)}
                                                                        sx={{
                                                                            position: "absolute",
                                                                            top: 4,
                                                                            right: 4,
                                                                            backgroundColor: "rgba(255,255,255,1)",
                                                                            borderRadius: "10%",
                                                                            border: "1px solid #D5D5D5",
                                                                            padding: "2px",
                                                                            "&:hover": {
                                                                                backgroundColor: "rgba(255,255,255,1)",
                                                                            },
                                                                        }}
                                                                    >
                                                                        <CloseIcon sx={{ color: "#454545", fontSize: "16px" }} />
                                                                    </IconButton>

                                                                    {/* File Name (with ellipsis) */}
                                                                    <Typography
                                                                        variant="body2"
                                                                        noWrap
                                                                        title={image?.name || "Invalid File"}
                                                                        sx={{
                                                                            fontWeight: 600,
                                                                            fontSize: "12px",
                                                                            mb: 0.5,
                                                                            width: "90px", // Ensures ellipsis works correctly
                                                                            textAlign: "center",
                                                                            overflow: "hidden",
                                                                            textOverflow: "ellipsis",
                                                                            display: "block",
                                                                        }}
                                                                    >
                                                                        {image?.name || "Invalid File"}
                                                                    </Typography>

                                                                    {/* Error Message (with wrapping) */}
                                                                    <Typography
                                                                        variant="caption"
                                                                        sx={{
                                                                            color: "#000",
                                                                            textAlign: "center",
                                                                            fontFamily: "Open Sans",
                                                                            fontSize: "12px",
                                                                            fontWeight: 400,
                                                                            lineHeight: "120%",
                                                                            wordBreak: "break-word",
                                                                            overflowWrap: "anywhere",
                                                                            whiteSpace: "normal",
                                                                            maxWidth: "90px",
                                                                            display: "block",
                                                                        }}
                                                                    >
                                                                        {fileSize > MAX_FILE_SIZE
                                                                            ? "Error: This file is too large (max 20 MB)"
                                                                            : "Error: Invalid format"}
                                                                    </Typography>
                                                                </Box>
                                                            )}
                                                        </Box>

                                                    </Grid>
                                                );
                                            })}
                                    </Grid>

                                            {open && (
                                                <Box
                                                    sx={{
                                                        position: "sticky",
                                                        bottom: "-4px",
                                                        width: "100%",
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    <Alert
                                                        severity="warning"
                                                        variant="outlined"
                                                        className="custom-alert-fixed"
                                                        sx={{
                                                            width: "100%",
                                                            maxWidth: "100%",
                                                            borderRadius: "8px",
                                                            boxSizing: "border-box",
                                                            minHeight: "30px",
                                                            padding: "8px 12px",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            fontSize: { xs: "10px", sm: "12px" },
                                                            lineHeight: 1.2,
                                                            border: "1px solid #FFD18E",
                                                            background: "#FFF5E5",
                                                            color: "black",
                                                            overflow: "visible",
                                                            whiteSpace: "normal",
                                                            wordWrap: "break-word",
                                                            flexWrap: "wrap",
                                                        }}
                                                    >
                                                        {remainingImages <= 0 ? (
                                                            <Typography
                                                                sx={{
                                                                    fontSize: { xs: "10px", sm: "12px" },
                                                                    lineHeight: 1.4,
                                                                    whiteSpace: "normal",
                                                                    wordBreak: "break-word",
                                                                }}
                                                            >
                                                                You've used up your daily credits. Your daily allowance will reset at
                                                                midnight.

                                                                You can still write comments manually.
                                                            </Typography>
                                                        ) : (
                                                            <Typography
                                                                sx={{
                                                                    fontSize: { xs: "10px", sm: "12px" },
                                                                    lineHeight: 1.4,
                                                                    whiteSpace: "normal",
                                                                    wordBreak: "break-word",
                                                                }}
                                                            >
                                                                You can analyze up to 10 images at a time.
                                                            </Typography>
                                                        )}
                                                    </Alert>
                                                </Box>
                                            )}


                                </Paper>
                            )}

                            {RenderContent()}
                        </div>

                    </Box>
                    {medialLibery && (
                        <Box
                            sx={{
                                padding: "10px !important",
                                boxSizing: 'border-box',
                                Height: '470px',
                                overflowY: 'hidden',
                                overflowX: 'hidden',
                                display: { xs: 'none', lg: 'block' },
                            }}
                        >

                            <ReportLibrarySideBar
                                value={value}
                                selectedImages={selectedImages}
                                setSelectedImages={setSelectedImages}
                                onDragtoggle={onDragtoggle}
                                setOnDragToggle={setOnDragToggle}
                                selectedMediaFiles={selectedMediaFiles}
                                setSelectedMediaFiles={setSelectedMediaFiles}
                                setMedialLibery={setMedialLibery}
                                name="Defect Finder"
                            />

                        </Box>
                    )}
                </Box>
            }
            {loading &&
                <Box display="flex" flexDirection={{ xs: "column", md: "row" }} width="100%" sx={{ overflowX: "hidden" }}>      {/* Sidebar */}
                    <div className={type == "non-narrative" ? "sidebar-container-non-narrative" : "sidebar-container"}>
                        {sidebarImages}
                    </div>
                    {/* Main content */}
                    {selectedContent ? (
                        <div className="content-container">
                            {/* Left */}
                            <div className="left-section">
                                <img
                                    src={selectedContent?.file_url}
                                    alt="Defect"
                                    className="defect-image"
                                />
                                <Box mt={1}>
                                    {/* <Typography
                                        variant="h6"
                                        sx={{
                                            fontFamily: "Source Sans Pro, sans-serif",
                                            fontWeight: 600,
                                            fontSize: "15px",
                                            lineHeight: "20px",
                                            letterSpacing: "0px",
                                            textTransform: "uppercase",
                                            fontStyle: "normal",
                                            mb: 1,
                                            color: "#979797"
                                        }}
                                    >
                                        Summary Section
                                    </Typography> */}
                                    {/* <Autocomplete
                                        multiple
                                        options={summaryOptions}
                                        getOptionLabel={(option) => option.label}
                                        value={summarySelections[selectedContent?.name] || []}
                                        onChange={(event, newValue) =>
                                            handleSummaryChange(selectedContent?.name, newValue)
                                        }
                                        clearIcon={null}
                                        renderTags={(selected, getTagProps) =>
                                            selected.map((option, index) => (
                                                <Chip
                                                    key={option.label}
                                                    label={
                                                        <Box display="flex" alignItems="center" gap="2px">
                                                            <Box
                                                                sx={{
                                                                    width: 12,
                                                                    height: 12,
                                                                    borderRadius: "2px",
                                                                    backgroundColor: option.color,
                                                                }}
                                                            />
                                                            {option.label}
                                                        </Box>
                                                    }
                                                    {...getTagProps({ index })}
                                                    sx={{
                                                        fontFamily: "Inter, sans-serif",
                                                        fontWeight: 600,
                                                        width: "fit-content",
                                                        height: "24px",
                                                        gap: "2px",
                                                        px: "6px",
                                                        pr: "2px",
                                                        py: "2px",
                                                        borderRadius: "25px",
                                                        border: "1px solid #ccc",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "flex-start",
                                                        color: "#637083",
                                                    }}
                                                />
                                            ))
                                        }
                                        renderOption={(props, option) => (
                                            <li {...props}>
                                                <Box display="flex" alignItems="center" gap={1}>
                                                    <Box
                                                        sx={{
                                                            width: 16,
                                                            height: 16,
                                                            borderRadius: "2px",
                                                            backgroundColor: option.color,
                                                        }}
                                                    />
                                                    {option.label}
                                                </Box>
                                            </li>
                                        )}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                placeholder={
                                                    (summarySelections[selectedContent?.name]?.length || 0) === 0
                                                        ? "No summary selected"
                                                        : ""
                                                }
                                                sx={{
                                                    width: "307px",
                                                    height: "40px",
                                                    "& .MuiOutlinedInput-root": {
                                                        height: "40px",
                                                        borderRadius: "4px",
                                                        padding: "0 8px 0 12px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        flexWrap: "nowrap",
                                                        overflowX: "auto",
                                                        "&::-webkit-scrollbar": {
                                                            display: "none",
                                                        },
                                                        "& fieldset": {
                                                            borderColor: "#ccc !important",
                                                            borderWidth: "1px !important",
                                                        },
                                                        "&:hover fieldset": {
                                                            borderColor: "#ccc !important",
                                                            borderWidth: "1px !important",
                                                        },
                                                        "&.Mui-focused fieldset": {
                                                            borderColor: "#ccc !important",
                                                            borderWidth: "1px !important",
                                                        },
                                                    },
                                                    "& .MuiInputBase-input": {
                                                        fontFamily: "Open Sans, sans-serif",
                                                        fontSize: "14px",
                                                        color: "#454545",
                                                        padding: 0,
                                                    },
                                                }}
                                            />
                                        )}
                                    /> */}
                                </Box>
                            </div>
                            {/* Right */}
                            <div className="right-section">
                                   {loadings || regenerationLoading || (selectedContent && dataLoading[selectedContent.name] === true) ? (
                                    <>
                                        <Skeleton variant="text" sx={{ fontSize: "1rem", height: "28px" }} />
                                        <Box height={"60vh"}>
                                            <Skeleton
                                                variant="rounded"
                                                height={"100%"}
                                                width={"100%"}
                                                sx={{ padding: "0px !important" }}
                                            />
                                        </Box>
                                    </>
                                ) : (
                                    <>
                                        {/* Title + Actions Row */}
                                        <Box display="flex" justifyContent="space-between" alignItems="flex-start">
                                            <div style={{ display: "flex", alignItems: "flex-start", gap: 3 }}>
                                                {!hasSelectedApologyMessage && (
                                                <Checkbox
                                                    checked={datas[selectedContent?.name]?.checked || false}
                                                    sx={{ py: 1, px: 0 }}
                                                    onChange={(e) =>
                                                        handleCheckbox(selectedContent?.name, e.target.checked)
                                                    }
                                                />)}
                                                <Typography
                                                    color={"#3B3B3B"}
                                                    fontWeight={600}
                                                    sx={{ fontSize: "18px !important", py: 0.5, px: 0 }}
                                                >
                                                    {selectedContent?.title || title}
                                                </Typography>
                                            </div>

                                            {/* UPDATED SECTION - Dropdown menu implementation */}
                                            {!hasSelectedApologyMessage && (
                                            <IconButton
                                                onClick={handleMenuOpen}
                                                sx={{
                                                    cursor: "pointer",
                                                    padding: "4px",
                                                    "&:hover": { backgroundColor: "transparent" },
                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        width: 32,
                                                        height: 32,
                                                        borderRadius: "4px",
                                                        gap: "8px",
                                                        transform: "rotate(0deg)",
                                                        opacity: 1,
                                                        p: "6px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                    }}
                                                    onClick={handleClickAi}
                                                >
                                                    {isClicked ? (
                                                        <AiEditIconHover style={{ width: "100%", height: "100%" }} />
                                                    ) : (
                                                        <AiEditIcon style={{ width: "100%", height: "100%" }} />
                                                    )}
                                                </Box>
                                            </IconButton>
                                            )}
                                            {!hasSelectedApologyMessage && (
                                            <Menu
                                                anchorEl={anchorEl}
                                                open={menuOpen}
                                                onClose={handleMenuClose}
                                                disableAutoFocusItem
                                                disableEnforceFocus
                                                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                                                transformOrigin={{ vertical: "top", horizontal: "right" }}
                                                PaperProps={{
                                                    elevation: 3,
                                                    sx: {
                                                        width: 260,
                                                        height: 244,
                                                        borderRadius: 2,
                                                        boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
                                                        "& .MuiMenuItem-root": {
                                                            fontSize: "14px",
                                                            fontWeight: 500,
                                                            color: "#3B3B3B",
                                                        },
                                                    },
                                                }}
                                                MenuListProps={{
                                                    disableListWrap: true,
                                                    onKeyDown: (e) => {
                                                        // Prevent MUI Menu from handling letter keys like "M", "R" etc.
                                                        e.stopPropagation();
                                                    },
                                                }}
                                            >

                                                <MenuItem
                                                    onClick={() => handleAction(currentPromptSettings.type === "Short" ? "Long" : "Short")}
                                                    sx={menuItemStyles}
                                                    disableRipple
                                                    onKeyDown={(e) => e.stopPropagation()}
                                                >
                                                    {currentPromptSettings.type === "Long" ? (
                                                        <>
                                                            <ShortMenu /> Make shorter
                                                        </>
                                                    ) : (
                                                        <>
                                                            <LongMenu /> Make longer
                                                        </>
                                                    )}
                                                </MenuItem>

                                                <MenuItem onClick={() => handleAction("addRecommendation")} sx={menuItemStyles}
                                                  disableRipple
                                                    onKeyDown={(e) => e.stopPropagation()}
                                                >
                                                    <AddrecMenu /> {currentPromptSettings.includeRecommendation ? "Remove recommendation" : "Add recommendation"}
                                                </MenuItem>
                                                <Divider />
                                                <MenuItem onClick={() => handleAction("editContext")} sx={menuItemStyles}
                                                  disableRipple
                                                    onKeyDown={(e) => e.stopPropagation()}
                                                >
                                                    <EditMenu /> Edit context
                                                </MenuItem>
                                                <MenuItem onClick={() => handleAction("regenerate")} sx={menuItemStyles}
                                                  disableRipple
                                                    onKeyDown={(e) => e.stopPropagation()}
                                                >
                                                    <RegenerateMenu /> Regenerate
                                                </MenuItem>
                                                <Divider />
                                                <Box display="flex" sx={{ px: 2, pt: 1, gap: 0.5 }}>
                                                    <InfoMenu style={{ marginRight: 8 }} />
                                                    <Typography
                                                        component="div"
                                                        sx={{
                                                            color: "#777777",
                                                            fontFamily: "Source Sans Pro",
                                                            fontSize: "13px",
                                                            lineHeight: "16px",
                                                        }}
                                                    >
                                                        Not satisfied? You can edit your
                                                        <br /> comment directly after you’ve
                                                        <br /> added it to your report.
                                                    </Typography>
                                                </Box>
                                                {/* Regenerate Popup (Separate Box) */}
                                                {showRegenerateBox && menuOpen && anchorEl && (
                                                    <Box
                                                        onClick={(e) => e.stopPropagation()}
                                                        onFocus={(e) => e.stopPropagation()}
                                                        sx={{
                                                            position: "fixed",
                                                            top: anchorEl.getBoundingClientRect().top + window.scrollY + 128,
                                                            left: anchorEl.getBoundingClientRect().left - 470 - 12,
                                                            width: 244,
                                                            height: 163,
                                                            borderRadius: 1,
                                                            border: "1px solid #E3E3E3",
                                                            bgcolor: "#FFFFFF",
                                                            p: 2,
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            gap: 2,
                                                            boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
                                                            zIndex: 1400,
                                                        }}
                                                    >
                                                        <Box sx={{ mx: -2, my: -2 }}>
                                                            <TextField
                                                                placeholder="Describe your changes"
                                                                variant="outlined"
                                                                size="small"
                                                                height="100%"
                                                                multiline={true}
                                                                rows={5}
                                                                fullWidth
                                                                value={editText}
                                                                onChange={(e) => setEditText(e.target.value)}
                                                                onFocus={(e) => e.stopPropagation()}
                                                                onKeyDown={(e) => e.stopPropagation()}
                                                                InputProps={{
                                                                    sx: {
                                                                        fontFamily: "Open Sans",
                                                                        "& fieldset": { border: "none" },
                                                                        "& input::placeholder": {
                                                                            color: "#BEBEBE",
                                                                            fontSize: 14,
                                                                            opacity: 1,
                                                                        },
                                                                    },
                                                                }}
                                                            />
                                                        </Box>

                                                        <Button
                                                            startIcon={<AutorenewIcon />}
                                                            variant="outlined"
                                                            disableElevation
                                                            disabled={!editText.trim() || manualPrompt === editText}
                                                            onClick={() => handleAction("editRegenerate")}
                                                            sx={{
                                                                width: "100%",
                                                                height: 32,
                                                                // mt: 10,
                                                                padding: "4px 18px !important",
                                                                borderRadius: 1,
                                                                border: "1px solid #4282E2",
                                                                bgcolor: "#FFFFFF",
                                                                fontFamily: "Source Sans Pro",
                                                                fontSize: 14,
                                                                fontWeight: 500,
                                                                textTransform: "none",
                                                            }}
                                                        >
                                                            Regenerate
                                                        </Button>
                                                    </Box>
                                                )}
                                            </Menu>
                                            )}
                                        </Box>

                                        {/* Description - aligned under the title */}
                                        <Typography
                                            component="div"
                                            dangerouslySetInnerHTML={{
                                                __html: formatAIResponseToHTML(selectedContent?.ai_response),
                                            }}
                                            sx={{
                                                fontSize: { xs: "16px !important", sm: "15px", md: "16px" },
                                                fontFamily: "Open Sans !important",
                                                letterSpacing: "-0.02em",
                                                lineHeight: { xs: "20px", sm: "22px", md: "25px" },
                                                color: "#3B3B3B",
                                                paddingLeft: "25px",
                                                fontStyle: "normal",
                                                wordBreak: "break-word",
                                                mt: 1,
                                            }}
                                        />
                                    </>
                                )}
                            </div>
                        </div>
                    ) : (
                        <Box
                            flex={{ xs: "1 0 auto", md: "0 0 72%" }}
                            display="flex"
                            flexDirection="column"
                            alignItems="center"
                            justifyContent="center"
                            sx={{
                                height: "66.2vh",
                                maxHeight: "66.2vh"
                            }}
                            gap={2}
                        >

                            <img src={LoadingIcon} alt="Loading" style={{ width: 178, height: 170, objectFit: "cover", borderRadius: 8 }} />
                            <Typography fontSize={1} sx={{ fontSize: "32px !important" }} fontWeight={700} color="#333">Analyzing image</Typography>
                            <Box display="flex" gap={1} alignItems="center" justifyContent="center">
                                <span className="spinner">
                                    {Array(8).fill(<div />)}
                                </span>
                                <Typography fontSize={30} sx={{ fontSize: "20px !important" }} fontWeight={400} color={"#333333"}>Scanning for defects</Typography>
                            </Box>
                            <Divider sx={{ width: "95px", height: "2px", ml: 2 }} />
                        </Box>
                    )}
                </Box>

            }
        </>
    )
}

export default AIDefectFinder;